import { deeplinkData } from './mock/deeplinkData.js';

angular.module('Toke').factory('deeplinkRepository', DeeplinkRepository);

DeeplinkRepository.$inject = ['$q'];

function DeeplinkRepository($q) {

    return {
        getDeeplinkData
    };

    function getDeeplinkData() {
        return $q.resolve(deeplinkData);
    }
}
